<template>
  <section class="performanceBg">
    <span class="careerGuideSubtitle">{{ t('careerGuide.section12Title') }}</span>

    <div class="performanceTableBorder">
      <table class="performanceTable">
        <thead>
          <tr>
            <th>{{ t('careerGuide.classLabel') }}</th>
            <th>{{ t('careerGuide.clubNameLabel') }}</th>
            <th>{{ t('careerGuide.directionLabel') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in performanceTable" :key="`performance-${index}`">
            <td>{{ item.parallel }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.direction }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="careerGuideTopInfo">
      <span class="careerGuideSubtitle">{{ t('careerGuide.directionsTitle') }}</span>
    </div>

    <div class="doughnutBody">
      <div class="doughnut">
        <CareerDonutChart :segments="segments" />
      </div>
      <div class="doughnutInfoList">
        <div v-for="item in performanceInfo" :key="item.text" class="doughnutInfoItem">
          <div class="doughnutInfoItemColor" :style="{ backgroundColor: item.color }"></div>
          <span class="doughnutInfoItemText">{{ item.text }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import CareerDonutChart from '@/components/career-guide/CareerDonutChart.vue';

const props = defineProps({
  performanceTable: {
    type: Array,
    default: () => []
  },
  performanceInfo: {
    type: Array,
    default: () => []
  }
});

const { t } = useI18n();

const segments = computed(() => {
  const counts = (props.performanceTable || []).reduce((acc, item) => {
    if (item?.direction && item.direction !== '-') {
      acc[item.direction] = (acc[item.direction] || 0) + 1;
    }
    return acc;
  }, {});

  return Object.keys(counts).map((key) => {
    const matched = props.performanceInfo.find((item) => item.text === key);
    return {
      value: counts[key],
      color: matched?.color || '#cccccc'
    };
  });
});
</script>

<style scoped>
.careerGuideSubtitle {
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #18191f;
}

.performanceBg {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.performanceTableBorder {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
}

.performanceTable {
  width: 100%;
  border-collapse: collapse;
}

.performanceTable th,
.performanceTable td {
  border: 1px solid #dee2e6;
  padding: 10px;
  font-size: 14px;
}

.performanceTable thead {
  background: #f5f6f7;
}

.careerGuideTopInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.doughnutBody {
  display: flex;
  gap: 24px;
}

.doughnutInfoList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.doughnutInfoItem {
  display: flex;
  align-items: center;
  gap: 12px;
}

.doughnutInfoItemColor {
  width: 20px;
  height: 20px;
  border-radius: 20px;
}

.doughnutInfoItemText {
  font-size: 16px;
  color: #18191f;
}

@media screen and (max-width: 768px) {
  .careerGuideSubtitle {
    font-size: 16px;
    line-height: 24px;
  }

  .doughnutBody {
    flex-direction: column;
    align-items: center;
  }

  .doughnutInfoList {
    width: 100%;
  }

  .doughnutInfoItemColor {
    width: 12px;
    height: 12px;
  }
}
</style>

